module.exports = __webpack_public_path__ + "static/result-cancel.35fe7b33.png";